export default __webpack_public_path__ + "static/media/bmr-women.385f9014.png";